import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = ["spreadPosition", "meaning", "revealNextCardButton", "revealSummaryButton"]
  static values = { readingId: String }

  connect() {
    this.cardPositions = this.spreadPositionTargets.filter(
      el => el.dataset.frontImageUrl && el.dataset.frontImageUrl.length > 0
    )

    const revealedCards = this.cardPositions.filter(el => el.dataset.filled === "true")
    const firstUnrevealedIndex = this.cardPositions.findIndex(el => el.dataset.filled === "false")

    if (revealedCards.length === 0) {
      this.currentIndex = 0
      if (this.cardPositions.length > 0) {
        this.animateCurrentCard()
      }
    } else {
      this.currentIndex = this.cardPositions.lastIndexOf(revealedCards[revealedCards.length - 1])
      const currentCard = this.cardPositions[this.currentIndex]
      if (this.hasMeaningTarget && currentCard) {
        this.meaningTarget.textContent = currentCard.dataset.meaning || ""
      }
    }

    this.updateButtonVisibility()
  }

  animateCurrentCard() {
    const cardEl = this.cardPositions[this.currentIndex]
    this.revealCard(cardEl)
  }

  nextCard() {
    const nextIndex = this.currentIndex + 1
    if (nextIndex < this.cardPositions.length) {
      this.currentIndex = nextIndex
      const cardEl = this.cardPositions[this.currentIndex]
      this.revealCard(cardEl)
      this.updateButtonVisibility()
    }
  }

  revealCard(cardEl) {
    this.spreadPositionTargets.forEach(el => {
      el.classList.remove("border", "border-4", "border-gold")
    })

    if (cardEl) {
      cardEl.classList.remove("border-gray-400", "border-2")
      cardEl.classList.add("border", "border-4", "border-gold")
    }

    if (!cardEl) return

    const meaning = cardEl.dataset.meaning || ""

    if (cardEl.dataset.filled === "false") {
      const frontImage = cardEl.dataset.frontImageUrl

      cardEl.classList.add(
        "transition-transform",
        "duration-500",
        "transform-style-preserve-3d"
      )

      setTimeout(() => {
        cardEl.style.backgroundImage = `url(${frontImage})`
      }, 250)

      cardEl.style.transform = "rotateY(180deg) scaleX(-1)"
      cardEl.dataset.filled = "true"
      cardEl.setAttribute("data-filled", "true")

      this.saveCardRevealed(cardEl)
    }

    if (this.hasMeaningTarget) {
      this.meaningTarget.textContent = meaning
    }

    this.updateButtonVisibility()
  }

  updateButtonVisibility() {
    const allRevealed = this.cardPositions.every(el => el.dataset.filled === "true")

    if (this.hasRevealNextCardButtonTarget) {
      if (allRevealed) {
        this.revealNextCardButtonTarget.classList.add("hidden")
      } else {
        this.revealNextCardButtonTarget.classList.remove("hidden")
      }
    }

    if (this.hasRevealSummaryButtonTarget) {
      if (allRevealed) {
        this.revealSummaryButtonTarget.classList.remove("hidden")
      } else {
        this.revealSummaryButtonTarget.classList.add("hidden")
      }
    }
  }

  async saveCardRevealed(cardEl) {
    const readingId = this.readingIdValue
    const spreadPositionId = cardEl.dataset.spreadPositionId

    await post(`/readings/${readingId}/save_card_revealed`, {
      body: JSON.stringify({ spread_position_id: spreadPositionId }),
      responseKind: "json"
    })
  }

  readingSummary() {
    window.location = `/readings/${this.readingIdValue}/summary`
  }
}
